import http from 'utils/http';
import { AgentTemplateResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getAgentTemplatesUrl } from './apiUrls';

export function getAgentTemplates(
  page: number,
  integration_code?: string,
  per_page?: number
): Promise<{ data: AgentTemplateResponse[]; meta: MetaApiResponse }> {
  const queryParams: Record<string, unknown> = { page };
  if (integration_code) {
    queryParams.integration_code = integration_code;
  }
  if (per_page) {
    queryParams.per_page = per_page;
  }
  return http.get(getAgentTemplatesUrl(), queryParams);
}
